const caseFileActions = {
    MOVE: "Move",
    ADD: "Add",
    REMOVE: "Remove",
};

const caseFileTypes = {
    FILE: "File",
    FOLDER: "Folder",
};

const sortNameCol = {
    DATE: "dateAdded",
    NAME: "title",
}

const sortByCol = {
    ASC: "asc",
    DESC: "desc",
}

export { caseFileActions, caseFileTypes, sortNameCol, sortByCol };